var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import './main.scss';
import desktop_pattern from '../../assets/images/featuredBlogs/blog_pattern_desktop.png';
import tablet_pattern from '../../assets/images/featuredBlogs/blog_pattern_tablet.png';
import mobile_pattern from '../../assets/images/featuredBlogs/blog_pattern_mobile.png';
import right_arrow from '../../assets/images/featuredBlogs/right_arrow.png';
var FeaturedBlogs = function (_a) {
    var _b;
    var data = _a.data;
    var _c = useState(window.innerWidth), width = _c[0], setWidth = _c[1];
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(function () {
        window.addEventListener('resize', handleWindowSizeChange);
        return function () {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    var isMobile = width < 768;
    var isTablet = width >= 768 && width < 1024;
    return (_jsxs("div", __assign({ className: "feature-blog-articles-main-container", style: {
            backgroundImage: isMobile
                ? "url(" + mobile_pattern + ")"
                : isTablet
                    ? "url(" + tablet_pattern + ") "
                    : "url(" + desktop_pattern + ")",
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
        } }, { children: [((_b = data[0]) === null || _b === void 0 ? void 0 : _b.title_block) && (_jsx("div", __assign({ className: "feature-blog-articles-title" }, { children: data[0].title_block }), void 0)),
            data.map(function (item, index) {
                return (_jsxs("a", __assign({ className: "feature-blog-article-container", href: item.cta.url, target: "" + (item.cta.is_external == true ? '_blank' : '_self') }, { children: [item.image && (_jsx("div", __assign({ className: "feature-blog-article-image" }, { children: _jsx("img", { src: item.image, alt: "article image" }, void 0) }), void 0)),
                        _jsxs("div", __assign({ className: "feature-blog-article-content" }, { children: [item.date && (_jsx("div", __assign({ className: "feature-blog-article-date" }, { children: item.date }), void 0)),
                                item.title && (_jsx("div", __assign({ className: "feature-blog-article-title" }, { children: item.title }), void 0)),
                                item.cta.url && item.cta.title && (_jsxs("div", __assign({ className: "feature-blog-article-cta" }, { children: [_jsx("div", __assign({ className: "feature-blog-article-cta-text" }, { children: item.cta.title }), void 0),
                                        _jsx("img", { className: "feature-blog-article-cta-arrow", src: right_arrow, alt: "right cta arrow" }, void 0)] }), void 0))] }), void 0)] }), index));
            })] }), void 0));
};
export default FeaturedBlogs;
